import { bulkPOActionTypes } from '@Actions/purchase/purchaseOrders/bulkPOActions';

const BulkPOReducers = (state = { }, action) => {
  switch (action.type) {
  case bulkPOActionTypes.GET_BULK_PO.LOADING: {
    const { getBulkPOLoading } = action;
    return {
      ...state,
      getBulkPOLoading,
    };
  }
  case bulkPOActionTypes.GET_BULK_PO.SUCCESS: {
    const { bulkPurchaseOrders } = action;
    return {
      ...state,
      bulkPurchaseOrders,
    };
  }
  case bulkPOActionTypes.CREATE_BULK_PO.LOADING: {
    const { createBulkPOLoading } = action;
    return {
      ...state,
      createBulkPOLoading,
    };
  }
  case bulkPOActionTypes.UPDATE_BULK_PO.LOADING: {
    const { updateBulkPOLoading } = action;
    return {
      ...state,
      updateBulkPOLoading,
    };
  }
  case bulkPOActionTypes.UPDATE_BULK_PO_STATUS.LOADING: {
    const { updateBulkPOStatusLoading } = action;
    return {
      ...state,
      updateBulkPOStatusLoading,
    };
  }
  case bulkPOActionTypes.GET_BULK_PO_BY_ID.LOADING: {
    const { getBulkPOByIdLoading } = action;
    return {
      ...state,
      getBulkPOByIdLoading,
    };
  }
  case bulkPOActionTypes.GET_BULK_PO_BY_ID.SUCCESS: {
    const { selectedBulkPO } = action;
    return {
      ...state,
      selectedBulkPO,
    };
  }
  case bulkPOActionTypes.DELETE_BULK_PO.LOADING: {
    const { deleteBulkPOLoading } = action;
    return {
      ...state,
      deleteBulkPOLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default BulkPOReducers;
